import jaLocale from './ja-locale';

interface LocaleMessages {
  [key: string]: any;
}

export const locales:LocaleMessages = {
  ja: jaLocale,
  en: {},
};